/* istanbul ignore file */
export * from './DisplaySettingsMobile';
